// src/lib/kinema/konva/renderers/CompositionRenderer.ts
import Konva from 'konva';
import type { KonvaRenderer } from './types';
import type { BaseLayerData } from '../../core/types';

export const CompositionRenderer: KonvaRenderer = {
  create(layer: BaseLayerData): Konva.Node {
    const group = new Konva.Group({
      clip: {
        x: 0, y: 0,
        width: layer.width,
        height: layer.height,
      },
    });
    return group;
  },
  update(node: Konva.Node, layer: BaseLayerData, changed: Record<string, boolean>): void {
    if (changed.width || changed.height) {
      (node as Konva.Group).clip({
        x: 0, y: 0, width: layer.width, height: layer.height,
      });
    }
  },
  destroy(node: Konva.Node): void { node.destroy(); },
};
